import React from 'react';
import PropTypes from 'prop-types';
import {
  Popover,
  OverlayTrigger,
  FormControl,
  Button,
  Row,
  Col
 } from 'react-bootstrap';
 import { JNApiKeyInstructions } from 'components';

class JNInitWizardPageOne extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show_api_info : false,
      show_jobnimbus_api_key_instructions : false
    }

    this.handleShowApiInfo = this.handleShowApiInfo.bind(this);
    this.handleHideApiInfo = this.handleHideApiInfo.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleShowApiInfo() {
    this.setState({ show_api_info : true });
    $(window).on('keydown', this.handleKeyDown);
  }

  handleHideApiInfo() {
    this.setState({ show_api_info : false });
    $(window).off('keydown', this.handleKeyDown);
  }

  handleKeyDown(e) {
    if(e.key == 'Enter') {
      this.handleHideApiInfo();
    }
  }

  componentWillUnmount() {
    $(window).off('keydown', this.handleKeyDown);
  }

  render() {
    const api_key_info_popover = (
      <Popover title='API Key' id='jn-integration-api-key-info-popover'>
        An API key is a special <i>token</i> (string of characters) used by
        web applications to verify the identity of a user.
      </Popover>
    );

    return (
      <div className='jn-init-wizard-pg-one-container'>
        <p>
          We will need your Job Nimbus
          <OverlayTrigger
            trigger='click'
            placement='right'
            overlay={api_key_info_popover}
            >
            <strong
              className='jobnimbus-integration-api-info-link'
              onClick={this.handleShowApiInfo}
              >
              {' '}API key{' '}
            </strong>
          </OverlayTrigger>
          to begin the initialization.
        </p>
        <p>
          <strong
            className='jobnimbus-integration-api-info-link'
            onClick={() => {this.setState({ show_jobnimbus_api_key_instructions : true })}}
            >
            Click Here{' '}
          </strong>
          For instructions on creating/finding your Job Nimbus API key.
        </p>
        <Row>
          <Col md={6} xs={6}>
            <FormControl
              type='text'
              placeholder='Enter your Job Nimbus API Key'
              onChange={this.props.handleApiKeyChange}
              value={this.props.api_key}
            />
          </Col>
        </Row>
        <JNApiKeyInstructions
          show={this.state.show_jobnimbus_api_key_instructions}
          onHide={() => {this.setState({ show_jobnimbus_api_key_instructions : false })}}
        />
      </div>
    );
  }
}

export default JNInitWizardPageOne;



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-init-wizard-pg-one.js